import { StartEllipsis, EndEllipsis } from './Pagination.types';
/**
 * Returns an array of pages with truncated start and end depending
 * on the currently selected page.
 * @param {number} page Currently selected item
 * @param {number} count Total amount of items
 * @returns {PaginationItem[]}
 */
export function getExtendedPages({ currentPage, totalPages, }) {
    let pages = Array.from({ length: totalPages }, (_, i) => i + 1);
    // no action for less than 7 items
    if (totalPages <= 6)
        return pages;
    // first and last chunks can be either 1 or 5 pages
    const firstPage = 1;
    const firstPages = pages.slice(0, 5);
    const lastPage = totalPages;
    const lastPages = pages.slice(lastPage - 5, lastPage);
    // show pages first to fifth if selected is first to fourth,
    // show first otherwise
    const startSegment = currentPage <= 4 ? firstPages : [firstPage];
    const truncateFirst = currentPage > 4;
    const middleSegment = currentPage > 4 && currentPage < lastPage - 3
        ? pages.slice(currentPage - 2, currentPage + 1)
        : [null];
    const truncateLast = currentPage < lastPage - 3 ||
        (totalPages === 7 && currentPage < lastPage - 2);
    // show pages 5th to last to last if selected 4th to last to last is one of them,
    // show last otherwise
    const endSegment = currentPage > lastPage - 4
        ? totalPages === 7 && currentPage < lastPage - 2
            ? [lastPage]
            : lastPages
        : [lastPage];
    pages = [
        ...startSegment,
        truncateFirst ? StartEllipsis : null,
        ...middleSegment,
        truncateLast ? EndEllipsis : null,
        ...endSegment,
    ].filter((page) => page !== null);
    return pages;
}
//# sourceMappingURL=getExtendedPages.js.map